import React, { Component } from 'react';
import { pick } from 'lodash';
import { mergeStyles } from 'wix-rich-content-common';
import { mergeBlockData, FORMATTING_BUTTONS, EditorState, getAnchorBlockData, InlineToolbarButton, ClickOutside } from 'wix-rich-content-editor-common';
import LineSpacingIcon from '../icons/LineSpacingIcon.js';
import Modal from 'react-modal';
import { s as styles, P as Panel } from '../LineSpacingPanel-05abb2c4.js';
import classNames from 'classnames';
import { LINE_SPACING_TYPE } from '../types.js';
import 'prop-types';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const lineHeight = "line-height";
const spaceBefore = "padding-top";
const spaceAfter = "padding-bottom";
class LineSpacingButton extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = null;
    this.onOpenPanel = () => {
      this.currentEditorState = this.oldEditorState = this.props.getEditorState();
      this.selection = this.oldEditorState.getSelection();
      const spacing = LineSpacingButton.getBlockSpacing(this.oldEditorState);
      this.oldSpacing = spacing;
      this.setState({ isPanelOpen: true, spacing });
    };
    this.openPanel = () => {
      var _a, _b;
      this.onOpenPanel();
      const { bottom, left } = this.buttonRef.getBoundingClientRect();
      (_b = (_a = this.props).setKeepOpen) == null ? void 0 : _b.call(_a, true);
      this.setState({ panelLeft: left, panelTop: bottom });
    };
    this.closePanel = () => {
      var _a, _b;
      this.setState({ isPanelOpen: false });
      (_b = (_a = this.props).setKeepOpen) == null ? void 0 : _b.call(_a, false);
    };
    this.updateSpacing = (spacing) => {
      var _a;
      const dynamicStyles = spacing;
      const { setEditorState, onUpdate, helpers } = this.props;
      const newEditorState = mergeBlockData(this.oldEditorState, { dynamicStyles });
      setEditorState(newEditorState);
      (_a = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _a.call(helpers, {
        buttonName: FORMATTING_BUTTONS.LINE_SPACING,
        pluginId: LINE_SPACING_TYPE,
        value: spacing == null ? void 0 : spacing["line-height"]
      });
      this.currentEditorState = newEditorState;
      onUpdate == null ? void 0 : onUpdate(dynamicStyles);
    };
    // eslint-disable-next-line
    this.save = (spacing) => {
      this.closePanel();
      if (spacing) {
        this.updateSpacing(spacing);
      } else {
        this.setEditorState(this.currentEditorState);
      }
    };
    this.cancel = () => {
      const { onUpdate } = this.props;
      this.setEditorState(this.oldEditorState);
      onUpdate == null ? void 0 : onUpdate(this.oldSpacing);
      this.closePanel();
    };
    this.setEditorState = (editorState) => this.props.setEditorState(this.fixSelection(editorState, this.selection));
    this.fixSelection = EditorState.forceSelection;
    this.state = { showPanel: false };
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.dataHookName = "LineSpacingButton";
  }
  static getBlockSpacing(editorState) {
    const { dynamicStyles = {} } = getAnchorBlockData(editorState);
    return pick(dynamicStyles, [lineHeight, spaceBefore, spaceAfter]);
  }
  static getModalParent() {
    return document.querySelector(".DraftEditor-root").parentNode;
  }
  render() {
    var _a;
    const {
      theme,
      helpers,
      isMobile,
      t,
      tabIndex,
      defaultSpacing,
      toolbar,
      toolbarName,
      inlinePopups
    } = this.props;
    const { isPanelOpen, spacing, panelTop, panelLeft } = this.state;
    const { styles: styles2 } = this;
    const icon = ((_a = toolbar == null ? void 0 : toolbar.icons) == null ? void 0 : _a.InsertPluginButtonIcon) || LineSpacingIcon;
    const modalStyle = isMobile ? { left: 0, bottom: 0, right: 0 } : {
      top: panelTop,
      left: panelLeft
    };
    if (isMobile || toolbarName !== "StaticTextToolbar" || !inlinePopups) {
      return /* @__PURE__ */ React.createElement(
        InlineToolbarButton,
        {
          onClick: this.openPanel,
          isActive: !!isPanelOpen,
          helpers,
          theme,
          isMobile,
          tooltipText: t("LineSpacingButton_Tooltip"),
          dataHook: this.dataHookName,
          formattingButtonName: FORMATTING_BUTTONS.LINE_SPACING,
          tabIndex,
          icon,
          pluginType: LINE_SPACING_TYPE,
          ref: (ref) => this.buttonRef = ref
        },
        /* @__PURE__ */ React.createElement(
          Modal,
          {
            isOpen: !!isPanelOpen,
            onRequestClose: () => this.save(),
            className: classNames(styles2.lineSpacingModal, {
              [styles2.lineSpacingModal_mobile]: isMobile
            }),
            overlayClassName: classNames(styles2.lineSpacingModalOverlay, {
              [styles2.lineSpacingModalOverlay_mobile]: isMobile
            }),
            parentSelector: LineSpacingButton.getModalParent,
            style: {
              content: modalStyle
            },
            ariaHideApp: false
          },
          /* @__PURE__ */ React.createElement(
            Panel,
            {
              spacing: __spreadValues(__spreadValues({}, defaultSpacing), spacing),
              onChange: this.updateSpacing,
              onSave: this.save,
              onCancel: this.cancel,
              styles: this.styles,
              t,
              isMobile,
              theme
            }
          )
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: styles2.lineSpacingPopup_button }, /* @__PURE__ */ React.createElement(
        InlineToolbarButton,
        {
          onClick: this.openPanel,
          isActive: !!isPanelOpen,
          helpers,
          theme,
          isMobile,
          tooltipText: t("LineSpacingButton_Tooltip"),
          dataHook: this.dataHookName,
          formattingButtonName: FORMATTING_BUTTONS.LINE_SPACING,
          tabIndex,
          icon,
          pluginType: LINE_SPACING_TYPE,
          ref: (ref) => this.buttonRef = ref
        },
        isPanelOpen && /* @__PURE__ */ React.createElement("div", { className: styles2.lineSpacingPopup }, /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside: () => this.save() }, /* @__PURE__ */ React.createElement(
          Panel,
          {
            spacing: __spreadValues(__spreadValues({}, defaultSpacing), spacing),
            onChange: this.updateSpacing,
            onSave: this.save,
            onCancel: this.cancel,
            styles: this.styles,
            t,
            isMobile,
            theme
          }
        )))
      ));
    }
  }
}

export { LineSpacingButton as default };
//# sourceMappingURL=LineSpacingButton.js.map
